import React from 'react';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_check_circle } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';
import VideoModal from '../shared/VideoModal';
import SafeComponent from '../shared/SafeComponent';
import { sendMixPanelEvent } from '../../utils/biEvents';
import { CLICKED_BRAND_VIDEO } from '../../utils/biEvents/events/mixPanelEvents';
import { LOHP_ROW, LOHP_INNER_ROW, MAX_WIDTH_CONTAINER } from '../../utils/constants';
import {
    videoUrl,
    sourceInfo,
    pictureData,
    imgSrc,
    subtitles
} from './config';

import './style.scss';

const reportBi = () => {
    sendMixPanelEvent({ eventName: CLICKED_BRAND_VIDEO });
};

const CheckIcon = () => (
    <Icon className="check-icon" color="#7A7D85" size={24}>{l_check_circle}</Icon>
);

const SellingProposition = () => (
    <div className={classNames('selling-proposition-wrapper', LOHP_ROW)}>
        <div className={classNames('selling-proposition', LOHP_INNER_ROW, MAX_WIDTH_CONTAINER)}>
            <div className="grid-15 flex-items-center">
                <div className="col-15-xs col-7-md selling-text">
                    <h2><I18n k="logged_out_homepage.selling_proposition.title"/></h2>
                    <ul>
                        <li>
                            <h6><CheckIcon/><I18n k="logged_out_homepage.selling_proposition.best_for_budget_sub_title"/></h6>
                            <p className="tbody-4"><I18n k="logged_out_homepage.selling_proposition.best_for_budget_details"/></p>
                        </li>
                        <li>
                            <h6><CheckIcon/><I18n k="logged_out_homepage.selling_proposition.quality_work_sub_title"/></h6>
                            <p className="tbody-4"><I18n k="logged_out_homepage.selling_proposition.quality_work_details"/></p>
                        </li>
                        <li>
                            <h6><CheckIcon/><I18n k="logged_out_homepage.selling_proposition.payment_protection_sub_title"/></h6>
                            <p className="tbody-4"><I18n k="logged_out_homepage.selling_proposition.payment_protection_pricing_details"/></p>
                        </li>
                        <li>
                            <h6><CheckIcon/><I18n k="logged_out_homepage.selling_proposition.support_sub_title"/></h6>
                            <p className="tbody-4"><I18n k="logged_out_homepage.selling_proposition.support_pricing_details"/></p>
                        </li>
                    </ul>
                </div>
                <div className="col-15-xs col-8-md">
                    <VideoModal imgSrc={imgSrc}
                        pictureData={pictureData}
                        videoUrl={videoUrl}
                        sourceInfo={sourceInfo}
                        subtitles={subtitles}
                        onOpen={reportBi}/>
                </div>
            </div>
        </div>
    </div>
);

export { SellingProposition };
export default SafeComponent(SellingProposition);
